<template>
   	<div class="nav" v-show="navShow">
   		<ul class="main">
   			<router-link to="/index"><li :class="{current:mainNum==1}" @click="changeMainNum(1)"><span>新歌</span></li></router-link>
   			<router-link to="/rank"><li :class="{current:mainNum==2}" @click="changeMainNum(2)"><span>排行</span></li></router-link>
   			<router-link to="/plist"><li :class="{current:mainNum==3}" @click="changeMainNum(3)"><span>歌单</span></li></router-link>
   			<router-link to="/singer"><li :class="{current:mainNum==4}" @click="changeMainNum(4)"><span>歌手</span></li></router-link>
   		</ul>
   	</div>
</template>

<script>
import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
      
      }
    },
    computed: {
    	...mapGetters(['mainNum','navShow'])
    },
    methods: {
    	changeMainNum(num){
    		this.$store.commit('setMainNum',num);
			this.$store.commit('searchFlag',0);
			//if(num==1){
				this.$store.commit('setIscurrent', -1);
			//}	
    	}
    }
  }
</script>

<style>
.nav{width: 100%;height: 42px;background: #1e1e1e;position: fixed;top:70px;z-index: 9;padding: 0px 18px;box-sizing: border-box;}
.main{width: 100%;height: 100%;}
.main li{float: left;width: 25%;height:100%;text-align: center;color: #fff;font-size: 14px;position: relative;transition: all 0.3s;}
.main li span{position: absolute;left:50%;top:50%;transform: translateX(-50%) translateY(-50%);}
.main .current{color: #7de87d;border-bottom: 3px solid #7de87d;box-sizing: border-box;height: 90%;}
</style>


// WEBPACK FOOTER //
// nav.vue?6937b9d3